import _ from 'lodash';

// 時・分を表す文字列(00:00)をx時間に直す
// ex) '01:30' => 1.5
function getHour(dataString) {
  if (!_.isString(dataString) || dataString.indexOf(':') === -1) {
    return 0;
  }

  const [hour, minute] = dataString.split(':').map(element => _.toNumber(element));

  return hour + (minute / 60);
}

// papa_dataからApp用のデータを得る
export default function getAppData(papaData) {
  const [header, ...data] = papaData;

  const indexOfTime = _.findIndex(header, title => title === '学習時間');

  if (indexOfTime === -1) {
    return [];
  }

  const appData = [];
  header.forEach((title, index) => {
    if (
      /_スコア$/.test(title) ||
      /_平均スコア$/.test(title)
    ) {
      // スコアが''または' 'の場合はテストを受験していないことを示すので、有効なデータのみ取り出す
      const validData = _.filter(data, datum => (datum[index] !== '' && datum[index] !== ' '));

      if (validData.length >= 1) {
        // 1人以上が受験済みのテストのみ、Chartに表示できる
        appData.push({
          index,
          name: title,
          data: validData.map(datum => ({
            time: getHour(datum[indexOfTime]),
            score: _.toNumber(datum[index]),
          })),
        });
      }
    }
  });

  return appData;
}



// WEBPACK FOOTER //
// ./es6/admin-common-js/apps/csv_chart/charts/portfolio/analysis/utils/getAppData.js